var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileMondayDevGray = function SvgMobileMondayDevGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    fillRule: "evenodd",
    d: "M7.303 4.197c0-1.096.88-1.984 1.966-1.984 3.66 0 6.625 2.992 6.625 6.686s-2.965 6.686-6.625 6.686H1.966A1.976 1.976 0 0 1 0 13.6c0-1.096.88-1.984 1.966-1.984H9.27c1.488 0 2.692-1.216 2.692-2.717S10.757 6.182 9.27 6.182a1.976 1.976 0 0 1-1.966-1.985",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    fillRule: "evenodd",
    d: "M2.751 8.899c0-3.694 2.966-6.686 6.625-6.686 1.086 0 1.967.888 1.967 1.984s-.88 1.985-1.967 1.985c-1.487 0-2.692 1.216-2.692 2.717 0 1.5 1.205 2.717 2.692 2.717h8.072v3.969H9.376c-3.66 0-6.625-2.993-6.625-6.686",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    d: "M19.196 13.127a.68.68 0 0 1 0 .954l-1.305 1.31c-.42.422-1.137.122-1.137-.477v-2.62c0-.599.717-.9 1.137-.477z"
  })));
};
export default SvgMobileMondayDevGray;